var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-envelope",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-envelope1",
    serifid: "iconB-envelope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.027,7.23c0.01,-0.224 0.022,-0.384 0.041,-0.593c0.06,-0.618 0.171,-1.066 0.368,-1.453c0.383,-0.753 0.995,-1.365 1.748,-1.748c0.735,-0.375 1.691,-0.436 3.616,-0.436l10.4,0c1.925,0 2.881,0.061 3.616,0.436c0.753,0.383 1.365,0.995 1.748,1.748c0.197,0.387 0.308,0.835 0.368,1.453c0.019,0.195 0.031,0.372 0.041,0.593c0.021,0.441 0.027,0.956 0.027,1.57l0,6.4c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-10.4,0c-1.925,0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-6.4c0,-0.614 0.006,-1.129 0.027,-1.57Zm19.973,1.691l-6.591,4.614c-0.815,0.57 -1.24,0.824 -1.683,0.935c-0.477,0.118 -0.975,0.118 -1.452,-0c-0.443,-0.111 -0.868,-0.365 -1.683,-0.935l-6.591,-4.614l0,6.279c0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l10.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-6.279Zm-17.931,-2.393l7.669,5.368c0.508,0.356 0.744,0.564 1.02,0.633c0.159,0.04 0.325,0.04 0.484,0c0.276,-0.069 0.512,-0.277 1.02,-0.633l7.669,-5.368c-0.034,-0.161 -0.081,-0.303 -0.149,-0.436c-0.192,-0.376 -0.498,-0.682 -0.874,-0.874c-0.549,-0.279 -1.272,-0.218 -2.708,-0.218l-10.4,0c-1.436,0 -2.16,-0.061 -2.708,0.218c-0.376,0.192 -0.682,0.498 -0.874,0.874c-0.068,0.133 -0.115,0.275 -0.149,0.436Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBEnvelope);
export default __webpack_public_path__ + "static/media/iconB-envelope.4fa6683c6e6c02f9281a61be0d8826b8.svg";
export { ForwardRef as ReactComponent };